<template>
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
</template>

<script setup lang="ts">
useHead({
  titleTemplate: (title) => (title ? `${title} - SAM Beheer` : "SAM Beheer"),
})

// Install dayJs adapter with custom locales
useInstallDayJsChartJsAdapter()

// register the route title cleanup
useRouteTitleCleanup()
</script>
